module.exports = __webpack_public_path__ + "img/09.2f773367.jpg";